import React, { useState, useEffect } from "react";
import { X, Minus, Square, Maximize2 } from "lucide-react";

interface CustomTitleBarProps {
  children?: React.ReactNode;
}

export const CustomTitleBar: React.FC<CustomTitleBarProps> = ({ children }) => {
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    const checkMaximized = async () => {
      const maximized = await window.electronAPI.window.isMaximized();
      setIsMaximized(maximized);
    };

    checkMaximized();

    // Listen for window state changes
    const handleResize = () => {
      checkMaximized();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMinimize = () => {
    window.electronAPI.window.minimize();
  };

  const handleMaximize = async () => {
    await window.electronAPI.window.maximize();
    setIsMaximized(!isMaximized);
  };

  const handleClose = () => {
    window.electronAPI.window.close();
  };

  return (
    <div className='flex items-center justify-between bg-secondary border-b px-4 py-2 select-none title-bar-draggable'>
      {/* Left side - App title and content */}
      <div className='flex items-center flex-1 min-w-0'>
        <div className='flex items-center gap-4 flex-1'>
          <h1 className='text-lg font-semibold text-secondary-foreground'>
            DrigonAI Local
          </h1>
          {children}
        </div>
      </div>

      {/* Right side - Window controls */}
      <div className='flex items-center gap-1'>
        <button
          onClick={handleMinimize}
          className='p-1 rounded hover:bg-secondary-foreground/10 transition-colors'
          title='Minimize'
        >
          <Minus className='h-4 w-4 text-secondary-foreground' />
        </button>
        <button
          onClick={handleMaximize}
          className='p-1 rounded hover:bg-secondary-foreground/10 transition-colors'
          title={isMaximized ? "Restore" : "Maximize"}
        >
          {isMaximized ? (
            <Square className='h-4 w-4 text-secondary-foreground' />
          ) : (
            <Maximize2 className='h-4 w-4 text-secondary-foreground' />
          )}
        </button>
        <button
          onClick={handleClose}
          className='p-1 rounded hover:bg-destructive hover:text-destructive-foreground transition-colors'
          title='Close'
        >
          <X className='h-4 w-4' />
        </button>
      </div>
    </div>
  );
};
